/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PodcastsPageQueryVariables = {||};
export type PodcastsPageQueryResponse = {|
  +whoAmI: ?{|
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>
  |},
  +podcasts: ?$ReadOnlyArray<?{|
    +id: string,
    +title: string,
    +downloadUrl: string,
    +description: string,
    +prettyPubDate: ?string,
    +durationSeconds: number,
    +prettyDuration: ?string,
    +series: {|
      +id: string,
      +title: ?string,
      +coverPhoto: string,
    |},
  |}>,
|};
export type PodcastsPageQuery = {|
  variables: PodcastsPageQueryVariables,
  response: PodcastsPageQueryResponse,
|};
*/


/*
query PodcastsPageQuery {
  whoAmI {
    groups {
      name
    }
    id
  }
  podcasts {
    id
    title
    downloadUrl
    description
    prettyPubDate
    durationSeconds
    prettyDuration
    series {
      id
      title
      coverPhoto
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PodcastType",
  "kind": "LinkedField",
  "name": "podcasts",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyPubDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationSeconds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SeriesType",
      "kind": "LinkedField",
      "name": "series",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coverPhoto",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PodcastsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PodcastsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "2fec2e325df8abff520781ee7c93f9af",
    "id": null,
    "metadata": {},
    "name": "PodcastsPageQuery",
    "operationKind": "query",
    "text": "query PodcastsPageQuery {\n  whoAmI {\n    groups {\n      name\n    }\n    id\n  }\n  podcasts {\n    id\n    title\n    downloadUrl\n    description\n    prettyPubDate\n    durationSeconds\n    prettyDuration\n    series {\n      id\n      title\n      coverPhoto\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '358e6da08042c46689627cb3711d7efe';

module.exports = node;
